import { IN_GAME_DIALOG_EVENT, type InGameDialogRequest } from "../components/InGameDialogHost";

function request<T extends string | boolean | undefined | void>(request: InGameDialogRequest): Promise<T> {
  return new Promise<T>((resolve) => window.dispatchEvent(new CustomEvent(IN_GAME_DIALOG_EVENT, { detail: { ...request, resolve } })));
}

export const gameAlert = (message: string, title = "Notice") => request<void>({ kind: "alert", title, message });
export const gameConfirm = (message: string, title = "Please confirm", confirmLabel = "Continue") => request<boolean>({ kind: "confirm", title, message, confirmLabel });
export const gamePrompt = (title: string, initialValue = "", message?: string, confirmLabel = "Save") => request<string | undefined>({ kind: "prompt", title, initialValue, message, confirmLabel });
